import styled from 'styled-components';
export const BKJDropdownMenuWrapper = styled.div `
  background-color: transparent;
  overflow-y: overlay;
  z-index: 1000;
  box-shadow: 0px 2px 8px rgba(13, 51, 32, 0.3);
  border-radius: 14px;
`;
//# sourceMappingURL=BKJDropdownMenu.styled.js.map